import { Building2, Check, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useActiveOrg } from '@/hooks/useActiveOrg';

export function OrgSwitcher() {
  const { orgs, active, loading, switchOrg } = useActiveOrg();
  if (loading) return null;
  if (orgs.length <= 1) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Building2 className="h-4 w-4 shrink-0" />
        <span className="max-w-[32vw] truncate sm:max-w-none">{active?.name || '-'}</span>
      </div>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Building2 className="h-4 w-4 shrink-0" />
          <span className="max-w-[28vw] truncate font-normal sm:max-w-none">
            {active?.name || 'בחר ארגון'}
          </span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[14rem]">
        {orgs.map((o) => (
          <DropdownMenuItem
            key={o.id}
            onClick={() => switchOrg(o.id)}
            className="gap-2"
          >
            {active?.id === o.id ? <Check className="h-4 w-4" /> : <span className="w-4" />}
            <span>{o.name}</span>
            <span className="ms-auto text-xs text-muted-foreground">{o.slug}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
